export { default as Manager } from './Manager';
export { default as Target } from './Target';
export { default as Popper, placements } from './Popper';
export { default as Arrow } from './Arrow';


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/node_modules/react-popper/lib/react-popper.js
// module id = 1557
// module chunks = 7